<template>
    <BaseElement v-model="value" :edit="edit" :create="create" :element="'button'">
        <template #main="{text}">
            <div class="switch">
                <button :class="{ 'switch_negative': !value.value}" :disabled="!edit" @click="value.value = false">{{ options[0] }}</button>
                <button :class="{ 'switch_positive': value.value}" :disabled="!edit" @click="value.value = true">{{ options[1] }}</button>
            </div>
        </template>
    </BaseElement>
</template>

<script>
import { defineAsyncComponent } from 'vue';
const Structure = defineAsyncComponent(() => import('@/components/Structure.vue'));
import BaseElement from '@/components/calculations/BaseElement.vue';

export default {
    components: {
        Structure,
        BaseElement
    },
    props: {
        modelValue: {},
        edit: {
            type: Boolean,
            required: false,
            default: false
        },
        create: {
            type: Boolean,
            required: false,
            default: false
        },
    },
    emits: ['update:modelValue'],
    data() {
        return {
        }
    },
    computed: {
        value: {
            get() {
                return this.modelValue
            },
            set(value) {
                this.$emit('update:modelValue', value)
            }
        },
        show: function () {
            return this.value && !this.value.hide;
        },
        options: function () {
            if (!this.value || !this.value.options) {
                return []
            }
            var data = []
            var lines = this.value.options.split("\n");
            for (var i = 0; i < lines.length; i++){
                data.push(lines[i]);
            }
            return data;
        },
    }
}
</script>
<style lang="scss">
</style>